<template>


  <v-expansion-panels style="z-index: 0; margin-top: 10px; ">
    <v-expansion-panel>
      <v-expansion-panel-header style="background-color: #eee">

        <!--div class="timepoint-group-container query-builder" style="margin-top: 10px;background-color: #eee;"-->
        <p style="margin: 0px 0px 0px 0px;color:black">
          <v-icon>mdi-group</v-icon>
          <b style="font-size: 14px; font-weight: 600; padding-left: 10px">
            {{ index }}
          </b>
        </p>
      </v-expansion-panel-header>

      <v-expansion-panel-content style="background-color: #eee; padding-top:10px; z-index: 0">
        <div class="rules-group-body query-builder">

          <div draggable="true" @dragstart="onDragStart(i)" @dragover.prevent @drop="onDrop(i)"
            class="rules-group-container" style="overflow: hidden;background: #cbd2d3;margin: 10px 10px 15px 10px;"
            v-for="(variableGroup, i) in localValue.values" v-bind:key="i">

            <div @click="toggleGroup(i)" style="
            float: left;
            cursor:pointer;
            display: inline-flex;float: left;padding: 4px;">

              <b>{{ localValue.groupVariable }} --> {{ i + 1 }}</b>
            </div>

            <v-icon @click="toggleGroup(i)" small color="red darken-2"> mdi-chevron-down </v-icon>

            <div style="display: inline-flex;float: right;">
              <v-btn style="margin: 0px" small elevation="2" @click="deleteGroup(i)">
                <v-icon small color="red darken-2"> mdi-delete </v-icon>
              </v-btn>
            </div>

            <div v-if="groupOpen[i]">

              <div v-for="(child, key) in variableGroup" :key="key" style="margin-bottom: 10px;">
                <component :is="child.type" :value="child" :type="child.type" :index="key"
                  @input="val => updateChild(i, key, val)" :entityId="entityId" :entity="entity" :languages="languages"
                  @save="save" />
              </div>

            </div>

          </div>
        </div>

        <div style="text-align: right">
          <v-btn small elevation="2" @click="addGroup">
            <v-icon color="green darken-2"> mdi-plus </v-icon>
          </v-btn>
        </div>
      </v-expansion-panel-content>

    </v-expansion-panel>
  </v-expansion-panels>

  <!--/div-->

</template>

<script>
// let { getList, getDetail } = require("@/api/base_entity");

export default {
  props: {
    value: { type: Object, default: () => null },
    config: { type: [Object, Array], default: null },
    index: { type: String, default: "" },
    entityId: { type: Number },
    entity: { type: String },
    languages: { type: Array, default: () => ["EN", "IT", "DE", "FR", "ES"] }
  },
  data() {
    return {
      values: [],
      groupOpen: {},
      dragged: null,
      // localValue: JSON.parse(JSON.stringify(this.value || this.config || {}))
      localValue: {}
    };
  },
  mounted() {
    this.initLocalValue();
  },
  watch: {
    value: {
      handler() {
        this.initLocalValue();
      },
      immediate: true,
      deep: true
    },
    config: {
      handler() {
        this.initLocalValue();
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    initLocalValue() {

      if (this.value && Object.keys(this.value).length > 0) {
        this.localValue = JSON.parse(JSON.stringify(this.value));
      } else if (this.config && Object.keys(this.config).length > 0) {
        this.localValue = JSON.parse(JSON.stringify(this.config));
      }
    },
    updateChild(groupIndex, fieldKey, newFieldValue) {
      const updated = JSON.parse(JSON.stringify(this.localValue));
      updated.values[groupIndex][fieldKey] = newFieldValue;
      this.$emit('input', updated);
    },
    addGroup() {
      this.localValue.values.push(JSON.parse(JSON.stringify(this.localValue.variables)));
      this.$emit('input', this.localValue)
    },
    deleteGroup(i) {
      this.localValue.values.splice(i, 1);
      this.$emit('input', this.localValue)
    },
    toggleGroup(i) {
      this.$set(this.groupOpen, i, !this.groupOpen[i])
    },
    onDragStart(i) {
      this.dragged = i;
    },
    onDrop(i) {
      const result = [...this.localValue.values];
      [result[this.dragged], result[i]] = [result[i], result[this.dragged]];
      this.localValue.values = result;
      this.$emit('input', this.localValue)
    },
    save(value) {
      this.$emit('save', value)
    }
  },
};
</script>

<style></style>